import Vue from 'vue'
import GAuth from 'vue-google-oauth2'
import VueYouTubeEmbed from 'vue-youtube-embed'
import Router from 'vue-router'
import UserSessionsBase from '@/components/UserSessionsBase'
import SessionBase from '@/components/SessionBase'
import OfflineSessionBase from '@/components/OfflineSessionBase'
import AcceptInviteBase from '@/components/AcceptInviteBase'
import DashboardBase from '@/components/DashboardBase'
import WCALoginPortal from '@/components/WCALoginPortal'
// TPC Components
import TPCBase from '@/components/TPC/Base'
import CompeteBase from '@/components/TPC/Compete/Base'
import EventBase from '@/components/TPC/Event/Base'
import ResultsBase from '@/components/TPC/Results/Base'
import AdminPanel from '@/components/TPC/Admin/AdminPanel'
import HallOfFameBase from '@/components/TPC/HallOfFame/Base'
import StreamerPanel from '@/components/TPC/Admin/StreamerPanel'
import WCAPanel from '@/components/TPC/Admin/WCAPanel'
// FMC Components
import FMCBase from '@/components/FMC/Base'
import FMCSessionBase from '@/components/FMC/Session/Base'

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)
Vue.use(VueYouTubeEmbed)
Vue.use(Router)
Vue.prototype.$backendHost = process.env.VUE_APP_ROOT_HOST
Vue.prototype.$backendApi = process.env.VUE_APP_ROOT_API

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/sessions',
      name: 'UserSessionsBase',
      component: UserSessionsBase,
      meta: {
        title: 'User Sessions'
      }
    },
    {
      path: '/session/:id',
      name: 'SessionBase',
      component: SessionBase,
      meta: {
        title: 'Session'
      }
    },
    {
      path: '/session/:id/:viewerType',
      name: 'SessionBaseSpectate',
      component: SessionBase,
      meta: {
        title: 'Session - Spectator'
      }
    },
    {
      path: '/sample-session',
      name: 'OfflineSessionBase',
      component: OfflineSessionBase,
      meta: {
        title: 'Sample Session'
      }
    },
    {
      path: '/invite/:id/:authToken',
      name: 'AcceptInviteBase',
      component: AcceptInviteBase,
      meta: {
        title: 'Accept Invite'
      }
    },
    {
      path: '/wca/login',
      name: 'WCALoginPortal',
      component: WCALoginPortal,
      meta: {
        title: 'WCA Login'
      }
    },
    {
      path: '/',
      name: 'DashboardBase',
      component: DashboardBase,
      meta: {
        title: 'Home'
      }
    },
    // TPC ROUTES
    {
      path: '/tpc',
      name: 'TPCBase',
      component: TPCBase,
      meta: {
        title: 'Twisty Puzzle Cup'
      }
    },
    {
      path: '/tpc/compete/:rid',
      name: 'CompeteBase',
      component: CompeteBase,
      meta: {
        title: 'Twisty Puzzle Cup - Compete'
      }
    },
    {
      path: '/tpc/event/:eid',
      name: 'EventBase',
      component: EventBase,
      meta: {
        title: 'Twisty Puzzle Cup - Event'
      }
    },
    {
      path: '/tpc/event/:eid/psychsheet',
      name: 'PsychSheetBase',
      component: EventBase,
      meta: {
        title: 'Twisty Puzzle Cup - Psych Sheet'
      }
    },
    {
      path: '/tpc/results/:rid/:sid',
      name: 'ResultsBase',
      component: ResultsBase,
      meta: {
        title: 'Twisty Puzzle Cup - Results'
      }
    },
    {
      path: '/tpc/admin',
      name: 'AdminPanel',
      component: AdminPanel,
      meta: {
        title: 'Admin Panel'
      }
    },
    {
      path: '/tpc/hall-of-fame',
      name: 'HallOfFame',
      component: HallOfFameBase,
      meta: {
        title: 'Hall of Fame'
      }
    },
    {
      path: '/tpc/stream',
      name: 'StreamerPanel',
      component: StreamerPanel,
      meta: {
        title: 'Streamer Panel'
      }
    },
    {
      path: '/tpc/wca',
      name: 'WCAPanel',
      component: WCAPanel,
      meta: {
        title: 'WCA Panel'
      }
    },
    // FMC ROUTES
    {
      path: '/fmc',
      name: 'FMCBase',
      component: FMCBase,
      meta: {
        title: 'FMC'
      }
    },
    {
      path: '/fmc/session/:sid',
      name: 'FMCSessionBase',
      component: FMCSessionBase,
      meta: {
        title: 'FMC Session'
      }
    },
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router
